// TODO: Maybe it would be wiser to fetch the combo/discount prestations from the API.

// HAIRCUT
export const WOMAN_HAIRCUT = 'woman_haircut';
export const WOMAN_SHAMPOO = 'woman_shampoo';
export const WOMAN_COLOR = 'woman_color';
export const WOMAN_FULLCOLOR = 'woman_fullcolor';
export const TIE_AND_DYE = 'tie_and_dye';
export const WOMAN_STREAKS = 'woman_streaks';
export const WOMAN_HAIR_HIGHLIGHTING = 'woman_hair_highlighting';
export const WOMAN_HAIR_PERMANENT = 'woman_hair_permanent';
export const MAN_COLOR = 'man_color';
export const MAN_CUT = 'man_cut';
export const MAN_SHAMPOO = 'man_shampoo';
export const BEARD_TRIM = 'beard_trim';
export const BEARD_SHAVE = 'beard_shave';
export const CREATIVE_HAIRCUT = 'creative_haircut';
export const HAIRCARE_PATINA = 'haircare_patina';
export const BRUSHING = 'brushing';
export const COMPLEX_BRUSHING = 'complex_brushing';
export const BRUSHING_LONG_HAIR = 'brushing_long_hair';

export const HAIRCUT_WOMAN_TECHNICAL_PRESTATIONS_WITHOUT_PATINA = [
  WOMAN_COLOR,
  WOMAN_FULLCOLOR,
  TIE_AND_DYE,
  WOMAN_STREAKS,
  WOMAN_HAIR_HIGHLIGHTING,
  WOMAN_HAIR_PERMANENT,
];

export const HAIRCUT_WOMAN_TECHNICAL_PRESTATIONS = [
  ...HAIRCUT_WOMAN_TECHNICAL_PRESTATIONS_WITHOUT_PATINA,
  HAIRCARE_PATINA,
];

export const WOMAN_HAIRCUT_PRESTATIONS = [WOMAN_HAIRCUT, CREATIVE_HAIRCUT];

export const HAIRCUT_BRUSHING_PRESTATIONS = [COMPLEX_BRUSHING, BRUSHING_LONG_HAIR];

// MASSAGE
export const FEET_MASSAGE = 'feet_massage';
export const BACK_MASSAGE_30MIN = 'back_massage_30min';

// BEAUTY
export const EYE_CARE = 'eye_care';
export const MANICURE = 'manicure';
export const NAIL_POLISH = 'nail_polish';
export const GREEN_NAILS_POLISH = 'green_nails_polish';
export const HANDS_GEL_NAIL_POLISH = 'hands_gel_nail_polish';
export const HANDS_NAIL_POLISH_PRESTATIONS = [
  NAIL_POLISH,
  'manicure_and_nail_polish',
  HANDS_GEL_NAIL_POLISH,
  'artificial_nails_and_nail_polish',
];
export const PEDICURE = 'pedicure';
export const PEDICURE_FULL = 'pedicure_full';
export const FEET_NAIL_POLISH = 'feet_nail_polish';
export const FEET_PERMANENT_NAIL_POLISH = 'feet_permanent_nail_polish';
export const PEDICURE_PRESTATIONS = [PEDICURE, PEDICURE_FULL];
export const FACE_CARE_SCRUB = 'face_care_scrub';
export const FACE_CARE_PRESTATIONS = [
  'radiance_care',
  'purifying_care',
  FACE_CARE_SCRUB,
  'face_care_anti_ageing',
  'face_care_moisturising',
];
export const FRENCH_SUPPLEMENT_HANDS = 'french_supplement_hands';
export const FRENCH_SUPPLEMENT_FEET = 'french_supplement_feet';
export const HAIR_REMOVAL_LIPS = 'hair_removal_lips';
export const HAIR_REMOVAL_FULL_LEGS = 'hair_removal_full_legs';
export const HAIR_REMOVAL_LEGS_OTHER = 'hair_removal_legs_other';
export const HAIR_REMOVAL_BIKINI_LINE_FULL = 'hair_removal_bikini_line_full';
export const HAIR_REMOVAL_INTERGLUTEAL_CLEFT = 'hair_removal_intergluteal_cleft';
export const BABYBOOMER_HANDS = 'baby_boomer_hands';
export const BABYBOOMER_FEET = 'baby_boomer_feet';

// CLEANING
export const CLEANING_RECURRING = 'recurring_house_cleaning';
export const CLEANING_SPOT = 'spot_house_cleaning';
// TODO: Currently these constants are only used by the pro app
// When the pro app will use the new cleaningPrestation we should clean the code to remove these constants
export const IRONING_RECURRING = 'recurring_ironing';
export const IRONING_SPOT = 'spot_ironing';
export const CLEANING_PRODUCTS = 'house_cleaning_products';
export const LINEN_OPTION = 'linen';

// CHILDCARE
export const RECURRING_CHILDCARE = 'recurring_childcare';
export const BABYSITTING_DAY = 'babysitting_day';
export const BABYSITTING_NIGHT = 'babysitting_night';

// MASSAGE
export const MASSAGE_DURATIONS = [30, 60, 90, 120];

// SPORTS COACHING
export const REMOTE_FITNESS_40_MIN = 'remote_fitness_40min';
export const REMOTE_STRETCHING_40_MIN = 'remote_stretching_40min';
export const REMOTE_THIS_ABS_BUTTOCKS_40_MIN = 'remote_thighs_abs_buttocks_40min';
export const REMOTE_CARDIO_TRAINING_40_MIN = 'remote_cardio_training_40min';

export const REMOTE_STRETCHING_60_MIN = 'remote_stretching_60min';
export const REMOTE_THIS_ABS_BUTTOCKS_60_MIN = 'remote_thighs_abs_buttocks_60min';
export const REMOTE_CARDIO_TRAINING_60_MIN = 'remote_cardio_training_60min';

export const AT_HOME_STRETCHING_60_MIN = 'at_home_stretching_60min';
export const AT_HOME_THIGHS_ABS_BUTTOCKS_60_MIN = 'at_home_thighs_abs_buttocks_60min';
export const AT_HOME_CARDIO_TRAINING_60_MIN = 'at_home_cardio_training_60min';
